<template>
  <div class="video-page page">
    <div class="top-bar">{{ $t("video.video") }}</div>

    <div class="content-shell">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="onLoad"
        >
          <div class="video-grid">
            <div
              v-for="(item, index) in data"
              :key="`${item.id}-${index}`"
              class="video-card"
              @click="toPlayVideo(item.id)"
            >
              <div class="thumb-wrap">
                <img :src="item.vod_pic" :alt="item.vod_name" class="thumb-img" />
              </div>
              <div class="video-title">{{ item.vod_name }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="page-spacer"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { normalizeMediaUrl } from "../../utils/media";

export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      data: [],
      page: 0,
      id: 888,
    };
  },
  methods: {
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 0;
        this.data = [];
      }

      this.loading = true;

      this.getVideoList()
        .then(() => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
            Toast(this.$t("reservation.refresh"));
          }
        })
        .catch(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },
    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    getVideoList() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: "get",
          data: { id: this.id, page: this.page },
          url: "video_list",
        })
          .then((res) => {
            const rows = ((res.data && res.data.data) || []).map((item) => ({
              ...item,
              vod_pic: normalizeMediaUrl(item.vod_pic),
            }));
            if (rows.length > 0) {
              const seenIds = new Set(this.data.map((item) => item.id));
              const nextRows = rows.filter((item) => !seenIds.has(item.id));
              this.data = this.data.concat(nextRows);
              this.page += 1;
              if (nextRows.length === 0) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>

<style scoped lang="less">
.video-page {
  min-height: 100%;
  background: #f4f4f4;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 84px;
  color: #111;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 1px;
  background: #fff;
  border-bottom: 1px solid #ededed;
}

.content-shell {
  width: calc(100% - 30px);
  margin: 16px auto 0;
  padding: 14px 12px 8px;
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 4px;
  box-sizing: border-box;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 14px;
}

.video-card {
  min-width: 0;
}

.thumb-wrap {
  width: 100%;
  aspect-ratio: 1.78 / 1;
  overflow: hidden;
  border-radius: 14px;
  background: #eee;
}

.thumb-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.video-title {
  margin-top: 8px;
  color: #1b1b1b;
  font-size: 12px;
  line-height: 18px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 36px;
}

.page-spacer {
  height: 160px;
}

::v-deep .van-pull-refresh__head {
  height: 72px;
}

::v-deep .van-pull-refresh__text,
::v-deep .van-loading__text {
  color: #666;
  font-size: 14px;
}
</style>
